module.exports = __webpack_public_path__ + "img/logbo-btn.25f3d5fa.png";